import { getLang, t } from '@shared/i18n';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config';

// fonction (et non constante) : les textes suivent la langue choisie au démarrage
const features = () => [
  {
    icon: '🛣️',
    title: t('Le tracé imposé', 'The set route'),
    text: t(
      'Le jour J, chaque participant reçoit le tracé du rallye et le suit sur la carte, virage par virage.',
      'On the day, every participant receives the rally route and follows it on the map, turn by turn.',
    ),
  },
  {
    icon: '🧭',
    title: t('Retour au parcours', 'Back on route'),
    text: t(
      'Hors du tracé ? FollowMe vous ramène au tracé par le chemin le plus court, sans demi-tour.',
      'Off the route? FollowMe takes you back to the route by the shortest way, without U-turns.',
    ),
  },
  {
    icon: '🔊',
    title: t('Guidage vocal', 'Voice guidance'),
    text: t(
      '« Dans 300 m, tournez à droite » : les instructions sont annoncées, la musique baisse un instant.',
      '“In 300 m, turn right”: instructions are spoken aloud and the music is lowered for a moment.',
    ),
  },
  {
    icon: '📍',
    title: t('Les autres en direct', 'Others live'),
    text: t(
      'Voyez les autres voitures du rallye sur la carte, et qui est hors parcours.',
      'See the other cars of the rally on the map, and who is off the route.',
    ),
  },
  {
    icon: '💬',
    title: t('Discussion', 'Chat'),
    text: t(
      'Une discussion par événement, avec photos, pour les participants et les organisateurs.',
      'One chat per event, with photos, for participants and organisers.',
    ),
  },
  {
    icon: '🏁',
    title: t('Historique', 'History'),
    text: t(
      'Distance, temps, vitesses moyenne et maximale : le résumé de chaque rallye terminé.',
      'Distance, time, average and top speed: a summary of every finished rally.',
    ),
  },
  {
    icon: '☕',
    title: t('Rassemblements', 'Meet-ups'),
    text: t(
      'Cars & Coffee, sorties sans tracé : un lieu, une heure de début et de fin.',
      'Cars & Coffee, outings without a route: a place, a start time and an end time.',
    ),
  },
  {
    icon: '🔔',
    title: t('Notifications', 'Notifications'),
    text: t(
      'Nouveaux événements, compte validé, nouveaux messages : vous ne ratez rien.',
      'New events, account approved, new messages: you never miss a thing.',
    ),
  },
];

export default function Home() {
  return (
    <>
      <section className="hero container">
        <span className="logo big">FM</span>
        <h1 style={{ marginTop: 24 }}>{t('Les rallyes routiers, ensemble.', 'Road rallies, together.')}</h1>
        <p className="lead">
          {t(
            'FollowMe guide chaque participant sur le tracé imposé du rallye, montre les autres voitures en direct et garde le souvenir de chaque sortie.',
            'FollowMe guides every participant along the set route of the rally, shows the other cars live and keeps a record of every outing.',
          )}
        </p>
        <div className="badges">
          <span className="btn">📱 {t("Bientôt sur l'App Store", 'Coming soon to the App Store')}</span>
          <Link to="/assistance" className="btn secondary">
            {t('Comment ça marche ?', 'How does it work?')}
          </Link>
        </div>
      </section>

      <section className="container">
        <div className="grid">
          {features().map((f) => (
            <div key={f.icon} className="card feature">
              <div className="icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p className="muted" style={{ margin: 0 }}>
                {f.text}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="container narrow">
        <h2>{t('Comment participer', 'How to take part')}</h2>
        <ol>
          <li>{t('Téléchargez FollowMe et créez votre compte.', 'Download FollowMe and create your account.')}</li>
          <li>
            {t(
              "Un organisateur valide votre compte : l'app est réservée aux participants de nos rallyes.",
              'An organiser approves your account: the app is reserved for participants in our rallies.',
            )}
          </li>
          <li>
            {t(
              'Touchez « Je participe » sur un événement. Le jour J, ouvrez la carte et partez !',
              'Tap “Join” on an event. On the day, open the map and off you go!',
            )}
          </li>
        </ol>
        <p className="muted">
          {getLang() === 'en' ? (
            <>
              Organiser? Manage your events, routes and members from the{' '}
              <Link to="/organisateur/connexion">organiser area</Link>.
            </>
          ) : (
            <>
              Organisateur ? Gérez vos événements, vos tracés et les membres depuis l'
              <Link to="/organisateur/connexion">espace organisateur</Link>.
            </>
          )}
        </p>
        <p className="muted">
          {t('Une question :', 'A question?')} <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
      </section>
    </>
  );
}
